// extracted by css-extract-rspack-plugin
export default {"verticalLayout":"O7rYb37J","verticalLayoutWide":"xqSN7Iv0"};